import classnames from 'classnames'
import { FunctionalComponent } from 'preact'
import Icon from '../assets'

export interface LoginAnchorProps {
  title: string
  ssoLoginUrl: string
}

const LoginAnchor: FunctionalComponent<LoginAnchorProps> = ({ title, ssoLoginUrl }) => {
  return (
    <a
      role='button'
      href={ssoLoginUrl || '#'}
      className={classnames(
        'header-login-button',
        'qa-header-login-button',
        'btn',
        'btn--secondary'
      )}
      onClick={(e) => {
        if (ssoLoginUrl) return
        e.preventDefault()
        window.app.events.commands.execute('modal:login:show')
      }}
    >
      <span aria-hidden='true' className='header-navigation-button-icon'>
        <Icon icon='person' color='currentColor' />
      </span>
      <span>{title}</span>
    </a>
  )
}

export default LoginAnchor
